export const PlaybookMessages = {
  MAIN: {
    TITLE: 'All Playbooks',
    SUBTITLE: 'Click on an playbook name for additional details',
  },

  tabs: ['Purchasing Standards', 'Regulatory Compliance'],
  PURCHASING_STANDARDS: 'Purchasing Standards',
  FILTER_DROPDOWN: {
    CONTRACT_TYPE: {
      TITLE: 'Contract Type',
      DROPDOWNOPTIONS: [],
      DROPDOWNVALUES: [],
    },
    STATUS: {
      TITLE: 'Status',
      DROPDOWNOPTIONS: [],
      DROPDOWNVALUES: [],
    },
    ACCEPTED_BY: {
      TITLE: 'Accepted By',
      DROPDOWNOPTIONS: [],
      DROPDOWNVALUES: [],
    },
  },
};
